import React, { useState } from 'react';
import StaffBio from '../../../modals/StaffBio';

const StaffMemberCard = ({ member }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <React.Fragment>
      <div
        className="
          bg-gray-800 rounded-lg shadow-lg text-center cursor-pointer
          transition-all duration-300 hover:shadow-sky-500/30 hover:shadow-2xl hover:scale-105
          flex flex-col items-center
          flex-none
          p-2
          sm:p-6
          w-[calc(50%_-_1rem)]
          sm:w-[calc(50%_-_1rem)]
          md:w-[calc(100%/3_-_calc(4rem/3))] 
          lg:w-[calc(25%_-_1.5rem)] 
        "
        onClick={() => {setIsModalOpen(true)}}
      >
        <img
          src={member.image}
          alt={member.alt}
          className="w-32 h-32 rounded-full mx-auto mb-5 object-cover shadow-md border-2 border-gray-700 group-hover:border-sky-500"
        />
        <h3 className="text-xl font-semibold text-sky-300 mb-1">{member.name}</h3>
        <p className="text-gray-400">{member.role}</p>
      </div>
      <StaffBio 
        member={member}
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
      />
    </React.Fragment>
  );
};

export default StaffMemberCard;